import React from 'react';
import Overlay from '../../../components/Overlay/Overlay';
import AnalyticsFilter from '../AnalyticsFilter/AnalyticsFilter';
const $ = require('jquery');

export function AnalyticsPopupTile(TileComponent) {

    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                popupModeOpened: false,
                compareModeOpened: false
            };
        }

        addCloseListeners = () => {
            document.addEventListener('mousedown', this.handleClickOutsideCb, true);
            document.addEventListener('keydown', this.onKeyCb, false);
        }

        removeCloseListeners = () => {
            document.removeEventListener('mousedown', this.handleClickOutsideCb, true);
            document.removeEventListener('keydown', this.onKeyCb, false);
        }

        handleClickOutsideCb = (e) => {
            if (e.target?.classList?.contains('overlay')) {
                this.close();
            }
        }

        onKeyCb = (e) => {
            let keyCode = e.keyCode;
            if (keyCode === 27) {
                if ($('.log-tooltip-overlay').length > 0) return;
                this.close();
            }
        }

        openCompare = () => {
            this.setState({ compareModeOpened: true });
            this.addCloseListeners();
        };

        openInPopup = () => {
            this.setState({ popupModeOpened: true });
            this.addCloseListeners();
        };

        close = () => {
            this.removeCloseListeners();
            this.setState({ popupModeOpened: false, compareModeOpened: false });
        };

        render() {
            const { popupModeOpened, compareModeOpened } = this.state;
            const { reports } = this.props;
            return <React.Fragment>
                {popupModeOpened && <Overlay className="analytics-popup-tile__modal-wrap-overlay">
                    <div className="analytics-popup-tile__modal-wrap">
                        <div className="analytics-popup-tile__inner-wrap">
                            <div className="analytics-popup-tile__filter-row">
                                <AnalyticsFilter
                                    {...this.props}
                                    canBeRenamed={false}
                                    canBeDeleted={false} />
                            </div>
                            <div className="analytics-popup-tile__modal-row">
                                <i className="icon icon-alan-header-menu-close analytics-popup-tile__close"
                                    onClick={this.close} />
                                <TileComponent
                                    {...this.props}
                                    mode="popup" />
                            </div>
                        </div>
                    </div>
                </Overlay>}
                {compareModeOpened && <Overlay className="analytics-popup-tile__compare-wrap-overlay">
                    <div className="analytics-popup-tile__compare-wrap">
                        <i className="icon icon-alan-header-menu-close analytics-popup-tile__compare-wrap-close"
                            onClick={this.close} />
                        {[...reports].map((report, index) => {
                            return <div
                                key={report.name}
                                className="analytics-popup-tile__column">
                                <div className="analytics-popup-tile__filter-row">
                                    <AnalyticsFilter
                                        {...this.props}
                                        report={report}
                                        canBeRenamed={false}
                                        canBeDeleted={false} />
                                </div>
                                <div className="analytics-popup-tile__modal-row compare-mode">
                                    <TileComponent
                                        {...this.props}
                                        report={report}
                                        mode="compare" />
                                </div>
                            </div>;
                        })}
                    </div>
                </Overlay>}
                <TileComponent
                    openInPopup={this.openInPopup}
                    openCompare={this.openCompare}
                    {...this.props} />
            </React.Fragment>;
        }
    };
}
